import sysfolder from './sysfolder';
import customerfolder from './customerfolder';
import auth from './auth';
import filemanager from './filemanager'
export default {
    sysfolder,
    customerfolder,
    auth,
    filemanager
}